// extracted by mini-css-extract-plugin
export var carrierIcon = "_uy-0";
export var carrierLogo = "_uy-1";
export var detailsSection = "_uy-2";